interface CognitoError {
  code: string;
}

export class AuthUtils {
  public static handleUnauthorizedCognitoError(err: unknown): void {
    if (!this.isCognitoError(err)) {
      console.error("Unexpected error:", err);

      return;
    }

    if (err.code === "NotAuthorizedException") {
      window.location.href = "/auth/login";
    }
  }

  private static isCognitoError(error: unknown): error is CognitoError {
    return typeof error === "object" && error !== null && "code" in error;
  }
}
